import styled from 'styled-components';
import { IThemeProvider } from '../../styles/theme';

export const SpinnerCont = styled.div`
  position: fixed;
  z-index: 1;
  top: 50%;
  left: 50%;

  .ant-spin-dot {
    font-size: 60px;

    .ant-spin-dot-item {
      width: 23.83px;
      height: 23.83px;
    }
  }
`;

export const ReportCont = styled.div`
  margin: 32px 0 0 0;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  ${({ theme }: IThemeProvider) => `
    padding: 0 0 0 0;
  `}
`;

export const ReportDetailsCont = styled.div`
  position: relative;
  flex-grow: 1;
  width: 1160px;
  align-self: center;
  display: flex;
  flex-direction: column;
  ${({ theme }: IThemeProvider) => `
    @media ${theme.layout.breakpoints.max.desktop} {
      width: 900px;
    }
    @media ${theme.layout.breakpoints.max.tablet} {
      width: 400px;
    }
  `}
`;
